import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinbhiwandi() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Bhiwandi and Taloja MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Bhiwandi and Taloja MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides dependable and professional Corporate Cab Services in Bhiwandi and Taloja MIDC, catering to the transportation needs of industrial plants, logistics hubs, warehouses, and corporate offices in these regions. Our fleet of well-maintained sedans, SUVs, and executive vehicles ensures safe, comfortable, and punctual travel for employees, supervisors, clients, and senior management. Whether it is daily staff transportation, industrial visits, airport transfers, business travel, or executive movement, we deliver smooth and hassle-free mobility solutions. With skilled chauffeurs, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a reliable and premium corporate travel experience for businesses operating in and around Bhiwandi and Taloja MIDC.',

    top: 'Top Places to Visit in Bhiwandi with Pune Corporate Car',

 "topPlaces": [
  {
    "title": "Nizampur Lake Garden",
    "description": "Nizampur Lake Garden is one of the most peaceful recreational spaces in Bhiwandi, featuring landscaped walkways, sitting areas, greenery, and a large lake at the center. Families visit in the mornings and evenings for walks, picnics, and fresh air away from the traffic and industrial areas. The reflection of the trees and skyline on the water creates a calm atmosphere, making it a soothing urban escape for relaxation and nature appreciation."
  },
  {
    "title": "Jama Masjid Bhiwandi",
    "description": "Jama Masjid is one of the oldest and most prominent religious landmarks in Bhiwandi, known for its traditional architectural style, spacious prayer halls, and peaceful ambiance. The mosque is a cultural and community hub, drawing worshippers throughout the day, especially during festivals like Eid when the entire area comes alive with prayers, lights, marketplaces, and festive energy. It stands as a symbol of Bhiwandi’s rich heritage and deeply rooted spiritual identity."
  },
  {
    "title": "Bhiwandi Fort (Bhadwad Fort remains)",
    "description": "Although mostly in ruins today, the remnants of Bhiwandi’s old fort area near Bhadwad offer a glimpse into the region’s historical past. The location once served as a strategic lookout point during earlier rule and trade activity in the region. Visitors who explore the site can enjoy views of surrounding green landscapes and learn about the lesser-known layers of Bhiwandi’s history, which often gets overshadowed by its industrial identity."
  },
  {
    "title": "Gaibi Dargah",
    "description": "Gaibi Dargah is one of the most respected spiritual places in the Bhiwandi region, drawing devotees from the city and surrounding rural areas. The dargah is associated with the memory and teachings of Sufi saints, known for their message of harmony, peace, and devotion. During annual Urs celebrations, the premises collect thousands of pilgrims, qawwali performances, food stalls, and colorful cultural offerings, creating a vibrant and soulful atmosphere."
  },
  {
    "title": "Vajreshwari Hot Water Springs (Nearby)",
    "description": "Located a short drive from Bhiwandi, Vajreshwari Hot Water Springs are famous for their naturally heated sulfur-rich waters believed to have therapeutic healing properties. The ancient Vajreshwari Temple, dedicated to Goddess Vajreshwari, stands nearby and adds spiritual significance to the experience. Visitors come here for holy baths, scenic forest surroundings, and a refreshing break from urban life."
  },
  {
    "title": "Tungareshwar Wildlife Sanctuary (Nearby)",
    "description": "Tungareshwar Wildlife Sanctuary, situated close to Bhiwandi, offers a dense forest escape with trekking routes, waterfalls in monsoon, birdlife, and scenic views of surrounding hills. Adventure seekers and nature lovers enjoy the trails leading to the Tungareshwar Mahadev Temple nestled deep within the forest. The sanctuary provides a refreshing break from industrial settings and is a favorite spot for weekend hikes and early morning nature walks."
  },
  {
    "title": "Riverfront Ghats of Bhiwandi",
    "description": "Several riverfront areas in and around Bhiwandi, especially near the Kamwari River, serve as scenic and community spaces where locals gather for evening walks, cultural rituals, and waterfront leisure. During festivals and traditional ceremonies, the ghats become vibrant with lamps, flowers, and devotional activities, reflecting the close connection between the city’s residents and their waterways."
  },
  {
    "title": "Ranjnoli Village Scenic Routes",
    "description": "Ranjnoli, located on the outskirts of Bhiwandi, offers rural landscapes filled with farms, open skies, village pathways, and seasonal greenery. Many travelers pass through this region while commuting, but those who stop discover beautiful agricultural landscapes, local food joints, and a refreshing countryside atmosphere. It is ideal for photography, village drives, and experiencing the rustic side of the region."
  },
  {
    "title": "Local Textile Markets",
    "description": "Bhiwandi is known across India as the ‘Manchester of Maharashtra’ because of its massive textile power loom industry. The city’s markets buzz with thousands of small and large manufacturers producing sarees, dress material, shirting fabric, and wholesale textile goods. Though industrial, the markets offer a fascinating look at the commercial heartbeat of the city and the livelihoods of thousands of workers who make Bhiwandi a major textile hub."
  },
  {
    "title": "Temples of Bhadwad and Kalher Region",
    "description": "Several small yet culturally significant temples in the Bhadwad and Kalher belt represent the devotional life of Bhiwandi’s rural and suburban communities. These temples often host seasonal fairs, devotional gatherings, and traditional festivals that showcase folk performance, local culture, and the community spirit that still survives strong in the town despite rapid industrialization."
  }
],


"services": [
{
"name": "Bhiwandi Staff Transportation",
"description": "Bhiwandi Staff Transportation offers reliable and organized transport solutions for employees working in Bhiwandi and nearby industrial areas. The service features trained drivers, GPS-enabled vehicles, multi-shift scheduling, and optimized routes to ensure safe, comfortable, and punctual daily commuting for corporate and factory staff."
},
{
"name": "Taloja MIDC Employee Cab",
"description": "Taloja MIDC Employee Cab provides structured and dependable cab services for employees working in Taloja MIDC. With professional drivers, GPS tracking, well-maintained vehicles, and organized routing, the service ensures safe and timely commute for industrial and corporate workers across all shifts."
},
{
"name": "Corporate Shuttle Bhiwandi Taloja",
"description": "Corporate Shuttle Bhiwandi Taloja delivers multi-passenger shuttle services for corporate offices, factories, and industrial units. The service includes GPS-monitored vehicles, trained chauffeurs, structured routes, and multi-shift support to guarantee efficient, safe, and comfortable employee mobility."
},
{
"name": "Worker Pickup Drop Taloja MIDC",
"description": "Worker Pickup Drop Taloja MIDC offers dependable daily transport for factory and industrial workers. The service ensures timely pickups and drops, safe commuting, GPS-enabled monitoring, and professional drivers for stress-free and organized shift-based transportation."
},
{
"name": "Industrial Transport Bhiwandi",
"description": "Industrial Transport Bhiwandi specializes in large-scale employee transportation for factories and industrial units. With trained drivers, GPS-enabled vehicles, structured routes, and multi-shift scheduling, the service ensures safe, timely, and reliable commuting for industrial staff."
},
{
"name": "Affordable Corporate Cab Taloja",
"description": "Affordable Corporate Cab Taloja provides cost-effective corporate transportation for office and industrial staff. The service emphasizes reliable pickups, well-maintained vehicles, professional drivers, GPS tracking, and structured daily schedules for safe and efficient commuting at competitive rates."
},
{
"name": "Monthly Cab Service Bhiwandi",
"description": "Monthly Cab Service Bhiwandi offers long-term cab rental solutions for companies needing consistent employee commuting. The service includes fixed monthly plans, trained chauffeurs, structured routes, GPS-enabled vehicles, and timely daily pickups to ensure dependable transportation."
},
{
"name": "Outstation Corporate Cab Taloja",
"description": "Outstation Corporate Cab Taloja provides long-distance transportation solutions for corporate employees, executives, and business trips. The service features GPS-enabled vehicles, trained drivers, optimized routes, and comfortable seating for safe, punctual, and hassle-free intercity travel."
},
{
"name": "Best Corporate Cab Provider Bhiwandi",
"description": "Best Corporate Cab Provider Bhiwandi offers premium-quality corporate cab services for office staff, executives, and industrial employees. The service ensures punctual pickups, professional chauffeurs, well-maintained vehicles, GPS tracking, and structured routes for seamless and comfortable commuting."
},
{
"name": "Company Cab Bhiwandi MIDC",
"description": "Company Cab Bhiwandi MIDC provides dedicated corporate transportation for office employees and industrial staff. The service includes trained drivers, GPS-enabled vehicles, structured routes, and comfortable seating to ensure reliable and safe commuting across Bhiwandi MIDC."
},
{
"name": "Business Taxi Taloja MIDC",
"description": "Business Taxi Taloja MIDC offers professional taxi services for corporate executives, office staff, and client visits. The service emphasizes punctual pickups, GPS-enabled monitoring, trained chauffeurs, and well-maintained vehicles for safe, comfortable, and efficient commuting."
},
{
"name": "Factory Worker Transport Bhiwandi",
"description": "Factory Worker Transport Bhiwandi delivers organized transportation for factory and industrial employees. The service features multi-passenger vehicles, structured routes, trained drivers, GPS-enabled tracking, and multi-shift support to ensure timely, safe, and efficient daily commuting."
},
{
"name": "SUV Cab Taloja MIDC",
"description": "SUV Cab Taloja MIDC provides spacious and comfortable SUVs for corporate teams, industrial staff, and long-distance commuting. The service includes trained chauffeurs, GPS tracking, optimized routes, and well-maintained vehicles for safe and reliable transport."
},
{
"name": "Sedan Cab Bhiwandi",
"description": "Sedan Cab Bhiwandi offers premium sedans for corporate travel, executive commuting, and office staff transportation. The service ensures punctual pickups, professional drivers, GPS-enabled vehicles, and a comfortable, safe, and stress-free commuting experience."
},
{
"name": "Corporate Fleet Bhiwandi Taloja",
"description": "Corporate Fleet Bhiwandi Taloja provides fully managed corporate fleet solutions including sedans, SUVs, and staff cabs. The service covers driver management, vehicle maintenance, GPS monitoring, and structured routes to deliver seamless, safe, and efficient employee transportation across Bhiwandi and Taloja."
}
],

"tableData": [
["Bhiwandi Staff Transportation", "Taloja MIDC Employee Cab"],
["Corporate Shuttle Bhiwandi Taloja", "Worker Pickup Drop Taloja MIDC"],
["Industrial Transport Bhiwandi", "Affordable Corporate Cab Taloja"],
["Monthly Cab Service Bhiwandi", "Outstation Corporate Cab Taloja"],
["Best Corporate Cab Provider Bhiwandi", "Company Cab Bhiwandi MIDC"],
["Business Taxi Taloja MIDC", "Factory Worker Transport Bhiwandi"],
["SUV Cab Taloja MIDC", "Sedan Cab Bhiwandi"],
["Corporate Fleet Bhiwandi Taloja", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Bhiwandi and Taloja MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate cab services in Bhiwandi and Taloja MIDC, ensuring seamless and efficient transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure timely pickups and drops, helping corporate staff reach offices, industrial zones, and business hubs in Bhiwandi and Taloja MIDC efficiently."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Bhiwandi and Taloja MIDC."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]
































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Bhiwandi and Taloja MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees in Bhiwandi and Taloja MIDC.',
  },
  {
    question: 'What types of corporate cab services are available in Bhiwandi and Taloja MIDC?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for industrial areas.',
  },
  {
    question: 'Do you support daily commuting for employees in Bhiwandi and Taloja MIDC?',
    answer: 'Yes, we provide optimized daily commute solutions with timely pickups and flexible shift scheduling for MIDC employees.',
  },
  {
    question: 'How can companies book corporate cab services in Bhiwandi and Taloja MIDC?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Bhiwandi and Taloja MIDC?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and terms.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Bhiwandi and Taloja MIDC?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Bhiwandi and Taloja MIDC?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manish Shirole',
    feedback: 'Excellent corporate cab service for Bhiwandi and Taloja MIDC employees. Timely, safe, and professional drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rucha Patil',
    feedback: 'Reliable and hassle-free corporate transportation in Bhiwandi and Taloja MIDC. Highly recommended.',
    rating: 5,
  },
];





























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Bhiwandi and Taloja MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-bhiwandi-taloja.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Bhiwandi and Taloja MIDC, offering staff transportation, worker pickup & drop, industrial area mobility, factory employee cabs, monthly corporate cab plans, shuttle services, business travel cabs, and chauffeur-driven executive cars for companies operating in Bhiwandi and Taloja MIDC.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-bhiwandi-taloja"
  }
};





  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Bhiwandi & Taloja MIDC | Staff & Industrial Transport</title>

  <meta
    name="description"
    content="Premium corporate cab services in Bhiwandi and Taloja MIDC including staff transportation, worker pickup & drop, industrial area cabs, business travel, factory worker transport, shuttle services, monthly corporate cab plans, and chauffeur-driven executive cars. Trusted by companies in Bhiwandi and Taloja MIDC."
  />

  <meta
    name="keywords"
    content="Bhiwandi Staff Transportation, Taloja MIDC Employee Cab, Corporate Shuttle Bhiwandi Taloja, Worker Pickup Drop Taloja MIDC, Industrial Transport Bhiwandi, Affordable Corporate Cab Taloja, Monthly Cab Service Bhiwandi, Outstation Corporate Cab Taloja, Best Corporate Cab Provider Bhiwandi, Company Cab Bhiwandi MIDC, Business Taxi Taloja MIDC, Factory Worker Transport Bhiwandi, SUV Cab Taloja MIDC, Sedan Cab Bhiwandi, Corporate Fleet Bhiwandi Taloja"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinbhiwandi;